import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900">吃瓜爆料</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              吃瓜爆料第一站，为您提供最新最全的娱乐八卦、明星动态、社会热点爆料内容。做最懂你的吃瓜平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="https://weibo.com/chiguabaoliao" target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="https://www.zhihu.com/org/chiguabaoliao" target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="知乎">
                <i className="ri-zhihu-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">快捷链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/yule-bagua" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  娱乐八卦
                </Link>
              </li>
              <li>
                <Link to="/category/shehui-redian" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  社会热点
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>contact@chiguabaoliao.com</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 吃瓜爆料 ChiguaBaoLiao.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}